import React from 'react';
import { Link } from 'react-router-dom';
import FormArea from './form';

const ContactMain = () => {
    return (
        <>
            <div className="contact__area section-padding">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-5 lg-mb-25">
                            <div className="contact__area-left mr-40 xl-mr-0">
                                <div className="title">
                                    <span className="subtitle wow fadeInLeft" data-wow-delay=".4s">Contact Us</span>
                                    <h2 className="title_split_anim mb-25">Contact Arclight Developers</h2>
                                    <p className="wow fadeInUp" data-wow-delay=".4s" style={{ fontSize: '17px', lineHeight: '1.8' }}>
                                        For project inquiries, civil work requirements, quotations, or business discussions, connect with Arclight Developers.
                                    </p>
                                    <p className="wow fadeInUp mt-15" data-wow-delay=".5s" style={{ fontWeight: '600', color: '#ff5e14', fontSize: '18px' }}>
                                        Let’s discuss your next infrastructure project with confidence.
                                    </p>
                                </div>
                                <div className="contact__area-left-contact wow fadeInUp mt-40" data-wow-delay=".7s">
                                    <div className="contact__area-left-contact-item">
                                        <div className="contact__area-left-contact-item-icon">
                                            <i className="flaticon-phone"></i>
                                        </div>
                                        <div className="contact__area-left-contact-item-content">
                                            <span>Mobile Number:</span>
                                            {/* Update with your actual number */}
                                            <h6><Link to="tel:+919909417333">+91 99094 17333</Link></h6>
                                            <h6><Link to="tel:+919558554419">+91 95585 54419</Link></h6>
                                        </div>
                                    </div>
                                    <div className="contact__area-left-contact-item">
                                        <div className="contact__area-left-contact-item-icon">
                                            <i className="flaticon-email-3"></i>
                                        </div>
                                        <div className="contact__area-left-contact-item-content">
                                            <span>Email ID:</span>
                                            {/* Update with your actual email */}
                                            <h6><Link to="mailto:info@arclightdevelopers.com">arclightdevelopers@gmail.com</Link></h6>
                                        </div>
                                    </div>
                                    <div className="contact__area-left-contact-item">
                                        <div className="contact__area-left-contact-item-icon">
                                            <i className="flaticon-location-1"></i>
                                        </div>
                                        <div className="contact__area-left-contact-item-content">
                                            <span>Office Address:</span>
                                            {/* Update with your actual address */}
                                            <h6><Link to="#" target="_blank">246/B, Purusangit Bunglow, Sector 7A, Gandhingar, Gujarat, 382007</Link></h6>
                                        </div>
                                    </div>
                                    <div className="contact__area-left-contact-item">
                                        <div className="contact__area-left-contact-item-icon">
                                            <i className="fa-regular fa-clock"></i>
                                        </div>
                                        <div className="contact__area-left-contact-item-content">
                                            <span>Working Hours:</span>
                                            <h6>Mon - Sat: 9:00 AM - 6:00 PM</h6>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-7 wow fadeInRight" data-wow-delay=".4s">
                            <div className="contact__area-form">
                                <h4>Send Message</h4>
                                {/* The form fields are rendered by this component */}
                                <FormArea />
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {/* Google Map Section */}
            <div className="map__area wow fadeInUp" data-wow-delay=".5s">
                {/* Replace the 'src' link below with your actual Google Maps embed link */}
                <iframe 
                    title="Arclight Developers Location"
                    src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d117506.11142511041!2d72.5713621!3d23.0201818!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x395e848aba5bd449%3A0x4fcedd11614f6516!2sAhmedabad%2C%20Gujarat!5e0!3m2!1sen!2sin!4v1698765432100!5m2!1sen!2sin" 
                    style={{ border: 0, width: '100%', height: '450px' }} 
                    allowFullScreen="" 
                    loading="lazy" 
                    referrerPolicy="no-referrer-when-downgrade">
                </iframe>
            </div>
        </>
    );
};

export default ContactMain;